import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import { useI18n } from 'vue-i18n'

import {
  availableCountryCode,
  availableCountryRows,
  resolveAvailableCountry,
} from '@/lib/onboardingCountry'

export function useOnboardingCountrySelect(options: {
  country: MaybeRefOrGetter<string>
  updateField: (field: string, value: string) => void
}) {
  const { t } = useI18n()

  const countrySelectItems = computed(() =>
    [...availableCountryRows()]
      .sort((a, b) => t(a.text).localeCompare(t(b.text)))
      .map((c) => ({
        title: t(c.text),
        value: String(c.countryCode).toLowerCase(),
      }))
  )

  /**
   * Select uses ISO alpha-2 `value`; parent `formData.country` stays a localized label
   * (or legacy English `value`).
   */
  const countrySelectModel = computed<string | null>({
    get() {
      return availableCountryCode(toValue(options.country), t)
    },
    set(v) {
      const row = resolveAvailableCountry(v, t)
      options.updateField('country', row ? t(row.text) : '')
    },
  })

  return { countrySelectItems, countrySelectModel }
}
